// samplingSites/state.js

export const samplingSitesInitialState = {
  isLoading: false,
  error: null,
  sites: [],
};
